import { Button, Div, Icon, Label, Loader, useWindowSize } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { useGameViewScreen } from "./useGameView";
import { adaptGameViewToGame } from "./gameViewAdapter";
// import GamePreview from "../../components/game/GamePreview";
import GamePreviewInfo from "../../components/game/GamePreviewInfo";
import GameActions from "../../components/game/game-actions/GameActions";
import GameInfo from "../../components/game/GameInfo";
import { usePlayerGroups } from "../../api/groups/GroupsSelector";
import { useEffect, useState } from "react";
import { ScrollView } from "react-native-gesture-handler";

export default function GameScreen({ navigation, route }: MainStackScreenProps<"game">) {
  const { game: gameView, loading } = useGameViewScreen(route.params.id);
  const playerGroups = usePlayerGroups();
  const [isOwner, setIsOwner] = useState(false);
  const { isMobile } = useWindowSize();

  // Convert IGameView to IGame for backward compatibility
  const game = gameView ? adaptGameViewToGame(gameView) : null;

  useEffect(() => {
    if (gameView?.group_id && playerGroups !== null && playerGroups.length) {
      const group = playerGroups.find((group: any) => group.id === gameView.group_id);
      if (group && group.is_owner) {
        setIsOwner(true);
      } else {
        setIsOwner(false);
      }
    }
  }, [gameView, playerGroups]);

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.navigate("home_remastered");
  };

  const editGame = () => {
    if (game?.id) {
      navigation.navigate("edit-game", { id: game.id });
    }
  };

  return (
    <ScreenLayout
      header={{
        center: `GAME`,
        left: <Icon name="arrow_back_ios" size={24} onPress={goBack} classNames={["mb-{5}"]} />,
        right: isOwner && <Icon name="edit" size={24} onPress={editGame} classNames={["mb-{5}"]} />,
      }}
    >
      {game ? (
        <ScrollView
          style={{
            flex: 1,
            paddingTop: 20,
            paddingBottom: 20,
            marginTop: -16,
            marginBottom: -16,
          }}
          showsVerticalScrollIndicator={false}
        >
          <GamePreviewInfo game={game} simpleView={isMobile} navigation={navigation} />
          <GameActions game={game} />
          <GameInfo game={game} navigation={navigation} />
        </ScrollView>
      ) : null}
      {!game ? (
        <Div classNames={["flex1", "alignContentCenter", "mt-{30}"]}>
          {loading ? (
            <Loader size="large" isLoading />
          ) : (
            <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight"]}>
              Game not found
            </Label>
          )}
        </Div>
      ) : null}
    </ScreenLayout>
  );
}
